import gql from 'graphql-tag';

export const QUERY_USER = gql`
  query user($userId: Int!) {
    users(where: { id: { _eq: $userId } }) {
      account_id
      email
      id
      first_name
      last_name
      onboarding_step
      phone_number
      groups {
        id
      }
    }
  }
`;

export const QUERY_TEAM = gql`
  query user($userId: Int!) {
    users(where: { id: { _neq: $userId } }) {
      id
      email
      first_name
      last_name
      phone_number
      groups {
        id
      }
    }
  }
`;

export const QUERY_GROUP = gql`
  {
    groups {
      id
      name
    }
  }
`;

export const QUERY_PHONE_NUMBERS = gql`
  query phoneNumbers($accountId: Int!) {
    phone_numbers(where: { account_id: { _eq: $accountId } }) {
      id
      name
      phone_number
    }
  }
`;

export const QUERY_CALL_FLOW = gql`
  query callFlow($phoneNumberId: Int!) {
    callflows(where: { phone_number_id: { _eq: $phoneNumberId } }) {
      id
      closed_flow
      open_flow
      group_id
      user_id
      working_hours
    }
  }
`;

// Checkout page: check if email is already in use
export const QUERY_GET_EMAILS = gql`
  query get_emails($email: String!) {
    users(where: { email: { _eq: $email }, role: { _eq: "manager" } }) {
      email
      id
      firstName
      lastName
    }
  }
`;

// Сheck groups for link with the user
export const QUERY_USER_FROM_GROUP = gql`
  query user_from_group($userId: Int!) {
    user_groups(where: { user_id: { _eq: $userId } })
  }
`;

export const QUERY_BRAIN_TREE_TOKEN = gql`
  {
    braintree_client_token {
      token
    }
  }
`;

// export const QUERY_S3_GREETING_UPLOAD = gql`
//   {
//     s3_greeting_upload {
//       key
//       url
//     }
//   }
// `;

/*
  This is an old user profile structure.
  Keep it for now as a reference for the local data structure.
  Ideally the local data structure should be updated to match the backend,
  but this will require complete Vuex Store overhaul.
 */
export const Q_PROFILE = gql`
  {
    profile {
      id
      firstName
      lastName
      email
      phone
      nonce
      numbers {
        id
        name
        number
        callFlow {
          id
          type
          toGroup {
            id
          }
          toPerson {
            id
          }
          callMenu {
            id
            action
            hoursType
            toPerson {
              id
            }
            toGroup {
              id
            }
            audioUrl
            callMenuItem {
              id
              key
              action
              toPerson {
                id
              }
              toGroup {
                id
              }
              audioUrl
            }
          }
        }
        textFlow {
          id
          type
          toGroup {
            id
          }
          toPerson {
            id
          }
          textMenu {
            id
            keywords
            type
            target
            toPerson {
              id
            }
            toGroup {
              id
            }
          }
          autoReplyEnabled
          autoReplyText
        }
      }
      team {
        id
        firstName
        lastName
        email
      }
      groups {
        id
        name
        members {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
export const S_USERS = gql`
  {
    users {
      id
      role
      first_name
      last_name
      phone_number
      email
      status
      offline_routing
      registration_username
      registration_password
      groups {
        id
      }
    }
  }
`;
